import { useEffect, useState } from 'react';
import {
  Button,
  Card,
  Grid,
  Space,
  Tabs,
  Typography,
  Alert,
  message,
} from 'antd';
import Profile from '../components/ProfileTabComponents/Profile';
import Application from '../components/ProfileTabComponents/PersonalDetails';
import Settings from '../components/ProfileTabComponents/Settings';
import Refer from '../components/ProfileTabComponents/Refer';
import AccountSettings from '../components/ProfileTabComponents/AccountSettings';
import styles from '../styles/Tabs.module.scss';
import { storageUtil } from '@/utils/storageUtil';
import BillingAndPayments from '../components/ProfileTabComponents/BillingAndPayments';
import { useDeleteUserMutation } from '../api/profileAPI';
import { useAppDispatch, useAppSelector } from '@/hooks/hooks';
import { clearAuthToken } from '@/store/slices/auth/authSlice';
import ContainerWrapper from '@/pages/layout/ContainerWrapper';
import ShareAccount from '../components/ProfileTabComponents/ShareAccount';
import HouseholdExpenditure from '../components/ProfileTabComponents/HouseholdExpenditure';
import { useResendRegisterEmailMutation } from '@/store/apis/authApi';
import { useFetchUserDataQuery } from '@/store/apis/userApi';

export const ProfilePage = () => {
  const [resendRegisterEmail, { isLoading: isResending }] =
    useResendRegisterEmailMutation();

  const { data: profileData, refetch } = useFetchUserDataQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const LOCAL_STORAGE_KEY = 'activeProfileTab';

  const getInitialActiveTab = () =>
    storageUtil.getItem<string>(LOCAL_STORAGE_KEY) || '1';

  const [activeKey, setActiveKey] = useState<string>(getInitialActiveTab());

  const handleTabChange = (key: string) => {
    setActiveKey(key);
    storageUtil.setItem(LOCAL_STORAGE_KEY, key);
  };

  const [deleteUser, { isLoading }] = useDeleteUserMutation();

  const [emailVerified, setEmailVerified] = useState(true);

  console.log('profileData', profileData?.data);

  useEffect(() => {
    if (profileData?.data?.isEmailVerified !== undefined) {
      setEmailVerified(profileData.data.isEmailVerified);
    }
  }, [profileData]);

  const handleSendVerification = () => {
    message.loading('Sending verification email...');
    resendRegisterEmail({ email: profileData?.data?.email || '' });
  };

  const { useBreakpoint } = Grid;

  const { xs, lg } = useBreakpoint();

  return (
    <ContainerWrapper>
      <div>
        {!emailVerified && (
          <Alert
            banner
            message={
              <Space
                direction={xs ? 'vertical' : 'horizontal'}
                wrap
                style={{
                  width: '100%',
                  justifyContent: xs ? 'start' : 'space-between',
                  rowGap: 8,
                }}
              >
                <Typography.Text
                  style={{
                    fontSize: xs ? 13 : 15,
                    textAlign: xs ? 'left' : 'inherit',
                    lineHeight: 1.4,
                  }}
                >
                  {xs
                    ? 'Please verify your email to unlock all features.'
                    : 'Please verify your email to continue. Some features may be limited until your email is verified.'}
                </Typography.Text>
                <Button
                  type="link"
                  onClick={handleSendVerification}
                  loading={isResending}
                  style={{
                    color: '#1890ff',
                    fontWeight: 600,
                    textDecoration: 'underline',
                    fontSize: xs ? 13 : 15,
                    padding: 0,
                    marginTop: xs ? 4 : 0,
                  }}
                >
                  Resend verification
                </Button>
              </Space>
            }
            type="warning"
            showIcon
            style={{
              marginTop: '0.5rem',
              padding: xs ? '5px 7px' : '8px 12px',
            }}
          />
        )}
        <Card
          title={
            <Typography.Title
              level={4}
              style={{
                margin: 0,
              }}
            >
              Profile Settings
            </Typography.Title>
          }
          style={{
            width: '100%',
            marginTop: '0.5rem',
          }}
        >
          <div
            style={{
              width: '100%',
              paddingRight: '2rem',
              height: '100%',
              margin: '20px',
            }}
          >
            <Tabs
              className={styles.tabs}
              activeKey={activeKey}
              onChange={handleTabChange}
              tabPosition={lg ? 'left' : 'top'}
              title="Profile Settings"
              tabBarStyle={{
                width: '100%',
                maxWidth: lg ? '250px' : '100%',
              }}
              tabBarExtraContent={{}}
              items={[
                {
                  key: '1',
                  label: (
                    <Typography.Text
                      style={{
                        margin: '0',
                        fontSize: '1.05rem',
                      }}
                    >
                      My Profile
                    </Typography.Text>
                  ),
                  children: <Profile />,
                },
                {
                  key: '2',
                  label: (
                    <Typography.Text
                      style={{
                        margin: '0',
                        fontSize: '1.05rem',
                      }}
                    >
                      Personal Details
                    </Typography.Text>
                  ),
                  children: <Application />,
                },
                {
                  key: '8',
                  label: (
                    <Typography.Text
                      style={{
                        margin: '0',
                        fontSize: '1.05rem',
                      }}
                    >
                      Household Expenditure
                    </Typography.Text>
                  ),
                  children: <HouseholdExpenditure />,
                },
                {
                  key: '3',
                  label: (
                    <Typography.Text
                      style={{
                        margin: '0',
                        fontSize: '1.05rem',
                      }}
                    >
                      Password & Security
                    </Typography.Text>
                  ),
                  children: <Settings />,
                },
                // {
                //   key: '4',
                //   label: (
                //     <Typography.Text
                //       style={{
                //         margin: '0',
                //         fontSize: '1.05rem',
                //       }}
                //     >
                //       Refer & Earn
                //     </Typography.Text>
                //   ),

                //   children: <Refer />,
                // },
                // {
                //   key: '5',
                //   label: (
                //     <Typography.Text
                //       style={{
                //         margin: '0',
                //         fontSize: '1.05rem',
                //       }}
                //     >
                //       Billing & Payments
                //     </Typography.Text>
                //   ),
                //   children: <BillingAndPayments />,
                // },
                // {
                //   key: '7',
                //   label: (
                //     <Typography.Text
                //       style={{
                //         margin: '0',
                //         fontSize: '1.05rem',
                //       }}
                //     >
                //       Share Account
                //     </Typography.Text>
                //   ),
                //   children: <ShareAccount />,
                // },
                // {
                //   key: '6',
                //   label: (
                //     <Typography.Text
                //       style={{
                //         margin: '0',
                //         fontSize: '1.05rem',
                //       }}
                //     >
                //       Account Settings
                //     </Typography.Text>
                //   ),
                //   children: <AccountSettings />,
                // },
              ]}
            />
          </div>
        </Card>
      </div>
    </ContainerWrapper>
  );
};
